import { TextInput } from './text.mjs';
import { registerCustomElement } from '../utils.mjs';

export class AnyInput extends TextInput {}

registerCustomElement('imt-input-any', AnyInput);
